import { PROMISE_TYPE_SUFFIXES } from '../redux/actions/types';

const [P, F, R] = PROMISE_TYPE_SUFFIXES;

export default function getPromiseTypes(TYPE) {
  return [`${TYPE}_${P}`, `${TYPE}_${F}`, `${TYPE}_${R}`];
}
